import type { PopoverProps } from '@mui/material';
import { Typography } from '@mui/material';

import IconButton from 'src/components/IconButton';

import { BodyContainer, BodySubTextContainer, Container, IconContainer, StyledPopover, TopContainer, WrapperContainer } from './styled';

import { ReactComponent as Close32Icon } from 'src/assets/svg/Close32.svg';
import { ReactComponent as WebIcon } from 'src/assets/svg/Web.svg';

type BlockClickPopoverProps = Omit<PopoverProps, 'children'>;

export default function BlockClickPopover({ onClose, ...remainder }: BlockClickPopoverProps) {
  return (
    <WrapperContainer data-is-open={remainder.open}>
      <StyledPopover onClose={onClose} {...remainder}>
        <Container>
          <TopContainer>
            <IconButton
              onClick={() => {
                onClose?.({}, 'backdropClick');
              }}
            >
              <IconContainer>
                <Close32Icon />
              </IconContainer>
            </IconButton>
          </TopContainer>
          <BodyContainer>
            <WebIcon />

            <Typography variant="h3">Connect from Web</Typography>

            <BodySubTextContainer>Please access the app from the web environment. Mobile app is not supported yet.</BodySubTextContainer>
          </BodyContainer>
        </Container>
      </StyledPopover>
    </WrapperContainer>
  );
}
